module.exports = __webpack_public_path__ + "static/img/2.21dd0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/04/1/2.png
// module id = Saw3
// module chunks = 2